import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { posthog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { AuthErrorDialog } from "@/components/custom/auth-error-dialog";
import { DevTools } from "@/components/custom/dev-tools";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "./lib/query-client";
import { router } from "./router";

const Providers = () => {
  return (
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <Toaster position="top-center" richColors />
        <RouterProvider router={router} />
        <AuthErrorDialog />
        <DevTools />
      </QueryClientProvider>
    </PostHogProvider>
  );
};

export default Providers;
